module.exports = __webpack_public_path__ + "bce1c0d8ba0031f71e7025806d3967eb.png";